import React, { useEffect, useState } from "react";
import * as S from "./styles";

const pad = (value) => String(value).padStart(2, "0");

const WEEKDAYS = [
  "domingo",
  "segunda",
  "terça",
  "quarta",
  "quinta",
  "sexta",
  "sábado",
];

const formatWeekday = (date) => WEEKDAYS[date.getDay()];

const formatDayMonth = (date) =>
  `${pad(date.getDate())}/${pad(date.getMonth() + 1)}`;

const formatHourMinute = (date) =>
  `${pad(date.getHours())}:${pad(date.getMinutes())}`;

const getTimeRemaining = (target) => {
  const total = target - Date.now();

  if (total <= 0) {
    return { total: 0, days: 0, hours: 0, minutes: 0, seconds: 0 };
  }

  return {
    total,
    days: Math.floor(total / (1000 * 60 * 60 * 24)),
    hours: Math.floor((total / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((total / 1000 / 60) % 60),
    seconds: Math.floor((total / 1000) % 60),
  };
};

const BlockedCard = ({
  badgeIcon = "🔒",
  badgeLabel = "AINDA NÃO É HORA",
  title,
  subtitle,
  releaseDate,
  counterLabel = "SIMULADO ABRE EM",
  actionLabel = "VER AULAS DE HOJE",
  onActionClick,
  onComplete,
}) => {
  const releaseDateObj = releaseDate ? new Date(releaseDate) : null;
  const releaseWeekday = releaseDateObj ? formatWeekday(releaseDateObj) : null;
  const releaseDayMonth = releaseDateObj
    ? formatDayMonth(releaseDateObj)
    : null;
  const releaseTime = releaseDateObj ? formatHourMinute(releaseDateObj) : null;

  const resolvedTitle =
    title ||
    (releaseWeekday
      ? `Calma, atleta. O simulado abre ${releaseWeekday}.`
      : "Calma, atleta. O simulado ainda não abriu.");

  const resolvedSubtitle =
    subtitle ||
    (releaseDayMonth
      ? `Liberamos o simulado ${releaseWeekday} (${releaseDayMonth}) às ${releaseTime}. Até lá, cola nas aulas ao vivo.`
      : "Volte quando a janela do simulado for liberada.");

  const targetTime = releaseDate ? new Date(releaseDate).getTime() : null;
  const [timeLeft, setTimeLeft] = useState(() =>
    targetTime ? getTimeRemaining(targetTime) : null,
  );

  useEffect(() => {
    if (!targetTime) return undefined;

    let intervalId;
    const tick = () => {
      const next = getTimeRemaining(targetTime);
      setTimeLeft(next);

      // Ao zerar, encerra o intervalo e avisa o pai para reavaliar a tela
      if (next.total <= 0) {
        clearInterval(intervalId);
        if (typeof onComplete === "function") onComplete();
      }
    };

    tick();
    intervalId = setInterval(tick, 1000);

    return () => clearInterval(intervalId);
  }, [targetTime, onComplete]);

  return (
    <S.Card>
      <S.Badge>
        <S.BadgeIcon>{badgeIcon}</S.BadgeIcon>
        <S.BadgeText>{badgeLabel}</S.BadgeText>
      </S.Badge>

      <S.Title>{resolvedTitle}</S.Title>

      {resolvedSubtitle && <S.Subtitle>{resolvedSubtitle}</S.Subtitle>}

      {timeLeft && (
        <S.CounterBox>
          <S.CounterLabel>{counterLabel}</S.CounterLabel>
          <S.CounterRow>
            <S.CounterCell>
              <S.CounterValue>{pad(timeLeft.days)}</S.CounterValue>
              <S.CounterUnit>DIAS</S.CounterUnit>
            </S.CounterCell>
            <S.CounterSeparator>:</S.CounterSeparator>
            <S.CounterCell>
              <S.CounterValue>{pad(timeLeft.hours)}</S.CounterValue>
              <S.CounterUnit>HORAS</S.CounterUnit>
            </S.CounterCell>
            <S.CounterSeparator>:</S.CounterSeparator>
            <S.CounterCell>
              <S.CounterValue>{pad(timeLeft.minutes)}</S.CounterValue>
              <S.CounterUnit>MIN</S.CounterUnit>
            </S.CounterCell>
            <S.CounterSeparator>:</S.CounterSeparator>
            <S.CounterCell>
              <S.CounterValue>{pad(timeLeft.seconds)}</S.CounterValue>
              <S.CounterUnit>SEG</S.CounterUnit>
            </S.CounterCell>
          </S.CounterRow>
        </S.CounterBox>
      )}

      {actionLabel && onActionClick && (
        <S.ActionButton type="button" onClick={onActionClick}>
          {actionLabel}
          <S.ArrowIcon>→</S.ArrowIcon>
        </S.ActionButton>
      )}
    </S.Card>
  );
};

export default BlockedCard;
